<mat-card class="stat-card" [class.backup-date-card]="stat.label === 'Utolsó manuális backup'">
  <mat-card-content>
    <div class="stat-content">
      <div class="stat-icon" [ngClass]="stat.iconClass">
        <mat-icon>{{ stat.icon }}</mat-icon>
      </div>
      <div class="stat-info">
        @if (stat.specialFormat) {
          <h3 class="stat-value">{{ stat.specialFormat.actualValue }} / {{ stat.specialFormat.planValue }}</h3>
        } @else {
          <h3 class="stat-value">{{ stat.value }}</h3>
        }
        <p class="stat-label">{{ stat.label }}</p>
      </div>
      @if (stat.change) {
        <span class="stat-change" [ngClass]="stat.change.type">{{ stat.change.value }}</span>
      }
    </div>
  </mat-card-content>
</mat-card>